class NewsletterBannerForm extends HTMLElement {
  connectedCallback() {
    this.form      = this.querySelector('form');
    this.emailInput = this.querySelector('input[type="email"]');
    this.errorEl   = this.querySelector('[role="alert"]');
    this.successEl = this.querySelector('[role="status"]');
    this.listId    = this.dataset.klaviyoListId;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();

    const email = this.emailInput.value.trim();

    if (!email || !this.emailInput.checkValidity()) {
      this.errorEl.classList.remove('hidden');
      return;
    }

    this.errorEl.classList.add('hidden');

    if (!this.listId) {
      console.warn('NewsletterBannerForm: Klaviyo list ID is not configured.');
      return;
    }

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache'
      },
      body: new URLSearchParams({
        g: this.listId,
        email,
        $source: 'Newsletter Form'
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.errors && data.errors.length) {
          this.errorEl.classList.remove('hidden');
          return;
        }
        this.successEl.classList.remove('hidden');
        this.successEl.focus();
      })
      .catch((error) => {
        console.error('Klaviyo subscribe error:', error);
        this.errorEl.classList.remove('hidden');
      });
  }
}

customElements.define('newsletter-banner-form', NewsletterBannerForm);
